import t from "utils/translate";
import { useMemo, useState } from "react";

import { PriceSelectionCard } from "./PriceSelectionCard";

import styles from "./styles.module.scss";

interface PriceSelectionProps {
  onSelect: (answer: number) => void;
  answer: string;
}

export const PriceSelection: React.FC<PriceSelectionProps> = ({
  onSelect,
  answer
}) => {
  const defaultActive = answer === "Yes" ? 0 : answer === "No" ? 1 : null;
  const [active, setActive] = useState<number | null>(defaultActive);

  const offersSchedule = useMemo(() => {
    try {
      const offersScheduleExpanded = JSON.parse(
        t("UNI_OFFERS_SCHEDULE_EXPANDED")
      );
      const currentDateTime = new Date().toLocaleString("en-US", {
        timeZone: "America/New_York"
      });
      const currentDateKey = currentDateTime.split(",")[0];
      return offersScheduleExpanded["CORE"][currentDateKey] || {};
    } catch {
      return {};
    }
  }, []);

  const content = [
    {
      onClick: () => {
        onSelect(0);
        setActive(0);
      },
      eyebrow: t("PRICE_SELECTION_YES_EYEBROW"),
      header: t("PRICE_SELECTION_YES_HEADER"),
      body: t("PRICE_SELECTION_YES_BODY"),
      price: t("PRICE_SELECTION_YES_PRICE"),
      subprice: t("PRICE_SELECTION_YES_SUBPRICE"),
      image: t("PRICE_SELECTION_YES_IMAGE"),
      terms: t("PRICE_SELECTION_YES_TERMS")
    },
    {
      onClick: () => {
        onSelect(1);
        setActive(1);
      },
      header: t("PRICE_SELECTION_NO_HEADER"),
      body: t("PRICE_SELECTION_NO_BODY"),
      price: offersSchedule?.price || t("PRICE_SELECTION_NO_PRICE"),
      image: t("PRICE_SELECTION_NO_IMAGE"),
      terms: offersSchedule?.offerTerms
    }
  ];

  return (
    <div className={styles.wrapper}>
      {content.map((item, index) => (
        <PriceSelectionCard key={index} item={item} active={active === index} />
      ))}
    </div>
  );
};
